import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    // Tanpa login, data otomatis terisi ke profilmu
    const [user] = useState({
        name: "Rony Saputra",
        role: "Admin",
        isLoggedIn: true,
        avatar: "/image_99839f.png"
    });

    return (
        <GlobalContext.Provider value={{ user }}>
            {children}
        </GlobalContext.Provider>
    );
};

export const useGlobalStore = () => useContext(GlobalContext);